import React from 'react';
import ProgressChatPanel from '../../components/ProgressChatPanel';

const ConnectChat = () => <ProgressChatPanel roleLabel="Teacher" />;

export default ConnectChat;
